import { Component, ElementRef, input, InputSignal, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DescriptorHelperService } from '../../descriptor.helper.service';
import { DescriptorPicklistService } from '../../descriptor.picklist.service';
import { TimerService } from '../../../UI-Lib/Utilities';
import { HelpModule } from '../../../UI-Lib/Help-Tooltip/help.module';
import * as _ from 'lodash';
import { AceLoaderComponent } from '../../../UI-Lib/ACE/Loader/loader.component';

export enum DescriptorFieldTypes {
    Text = 2,
    Number = 3,
    Date = 4,
    Picklist = 5,
    YesNo = 6,
    Currency = 7,
}

@Component({
    selector: 'descriptor-validation',
    templateUrl: './descriptorValidation.component.html',
    styleUrls: ['./descriptorValidation.component.scss'],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, HelpModule, AceLoaderComponent],
})
export class DescriptorValidationComponent implements OnInit {
    constructor(
        private readonly _picklistService: DescriptorPicklistService,
        private readonly _toastr: ToastrService,
        private readonly _helperService: DescriptorHelperService,
        private readonly _timer: TimerService,
    ) {}

    @ViewChild('itemToAdd') itemToAdd: ElementRef;

    validationForm: InputSignal<FormGroup> = input.required();
    descriptorForm: InputSignal<FormGroup> = input.required();
    descriptorId: InputSignal<number> = input.required();
    fieldTypeId: InputSignal<DescriptorFieldTypes> = input.required();

    picklist: Weissman.Model.Descriptors.DescriptorPickList[];
    formats: Weissman.Model.Descriptors.DescriptorFormat[];
    FieldTypes = DescriptorFieldTypes;
    picklistLoading: boolean = false;
    picklistSaving: boolean = false;
    itemToAddText: string = '';
    addingItem: boolean = false;

    async ngOnInit(): Promise<void> {
        const descriptor = this.descriptorForm().getRawValue();

        if (descriptor.pickListGroupID) {
            this.picklistLoading = true;
            const canLimitToList = await this._picklistService.canLimitToList(
                this.descriptorId(),
                descriptor.pickListGroupID,
            );
            if (!canLimitToList) {
                this.validationForm().get('limitToList').disable();
            }
            const picklist = await this._picklistService.getByPicklistGroupId(descriptor.pickListGroupID);
            this.picklist = _.sortBy(picklist, 'name');
            this.picklistLoading = false;
        }

        this.formats = await this._helperService.getFormats();
    }

    async savePicklistItem(item: Weissman.Model.Descriptors.DescriptorPickList): Promise<void> {
        this.picklistSaving = true;
        await this._picklistService.updateItem(item);
        this.picklistSaving = false;
    }

    async deletePicklistItem(item: Weissman.Model.Descriptors.DescriptorPickList): Promise<void> {
        const result = await this._picklistService.deleteItemById(item.descriptorPickListID);

        if (result) {
            item.disabled = true;
        } else {
            _.remove(this.picklist, item);
        }
    }

    showPicklistItemInput(): void {
        this.addingItem = true;

        this._timer.setTimeout(() => this.itemToAdd.nativeElement.focus());
    }

    async addPicklistItem(): Promise<void> {
        if (!_.trim(this.itemToAddText)) {
            this._toastr.error('Picklist item must not be empty!');
            return;
        }

        const descriptor = this.descriptorForm().getRawValue();

        const picklistItemToAdd = {
            disabled: false,
            name: this.itemToAddText,
            groupID: descriptor.pickListGroupID || 0,
        } as Weissman.Model.Descriptors.DescriptorPickList;

        this.picklistSaving = true;
        const result = await this._picklistService.createItem(picklistItemToAdd);

        this.descriptorForm()
            .get('pickListGroupID')
            .patchValue(descriptor.pickListGroupID || result.groupID);

        this.picklist = this.picklist || [];
        this.picklist.push(result);
        this.itemToAddText = '';
        this.addingItem = false;
        this.picklistSaving = false;
    }
}
